export default {
    'APP_JOB_VIEW': 'APP_JOB_VIEW',
    'APP_JOB_UPDATE': 'APP_JOB_UPDATE',
    'APP_CUSTOM_FREQ_VIEW': 'APP_CUSTOM_FREQ_VIEW',
    'APP_COMMERCE_VIEW': 'APP_COMMERCE_VIEW',
    'APP_MAARG_JOB_CRON_UPDATE': 'SJ_CRON_UPDATE',
    'APP_MAARG_JOB_PARAMETERS_UPDATE': 'SJ_PARAMETERS_UPDATE',
    'APP_MAARG_JOB_RUN_NOW_UPDATE': 'SJ_RUN_NOW',
    'APP_MAARG_JOB_STATUS_UPDATE': 'SJ_STATUS_UPDATE'
}